import React, { InputHTMLAttributes } from 'react';
interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label: string;
  value: string;
  onChange: (value: string) => void;
  suffix?: string;
  hint?: string;
  error?: string;
}
export function TextField({
  label,
  value,
  onChange,
  suffix,
  hint,
  error,
  id,
  className = '',
  ...rest
}: TextFieldProps) {
  const inputId = id ?? `field-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
  return <div className={className} data-id="element-1163" data-mp="hy6bt6pwk7d">
      <label htmlFor={inputId} className="block text-xs font-medium text-slate-600" data-id="element-1164" data-mp="3rq2k9mcxp1f5">
        {label}
      </label>
      <div className="relative mt-1.5" data-id="element-1165" data-mp="3msk9dqfcwc4i">
        <input id={inputId} value={value} onChange={e => onChange(e.target.value)} aria-invalid={Boolean(error)} className={`h-11 w-full rounded-xl border-0 bg-white px-3.5 text-sm text-navy ring-1 ring-inset placeholder:text-slate-300 focus:outline-none focus:ring-2 ${error ? 'ring-rose-300 focus:ring-rose-400' : 'ring-slate-200 focus:ring-azure'} ${suffix ? 'pr-16' : ''}`} {...rest} data-id="element-1166" data-mp="3mtllzzc0t6oc" />
        {suffix && <span className="pointer-events-none absolute right-3.5 top-1/2 -translate-y-1/2 text-xs text-muted" data-id="element-1167" data-mp="1gizi6y8pn53a">{suffix}</span>}
      </div>
      {error ? <p className="mt-1 text-xs text-rose-600" data-id="element-1168" data-mp="16mczaezy2o3w">{error}</p> : hint && <p className="mt-1 text-xs text-muted" data-id="element-1169" data-mp="16opqzjvi8cu5">{hint}</p>}
    </div>;
}